export default {
  CLOSED_BY_USER: 'closed-by-user',
  SUCCEED: 'succeed',
};
